/**
 * useUserRitualPractices Hook
 * Fetches rituals user is organizing but didn't create
 */

import { useQuery } from "@tanstack/react-query"
import { getUserRitualPractices } from "../services/user-rituals.service"

interface UseUserRitualPracticesOptions {
  page?: number
  limit?: number
  search?: string
  subTab?: string
  enabled?: boolean
}

export function useUserRitualPractices(userId: string, options?: UseUserRitualPracticesOptions) {
  return useQuery({
    queryKey: [
      "user-ritual-practices",
      userId,
      options?.page,
      options?.limit,
      options?.search,
      options?.subTab,
    ],
    queryFn: () =>
      getUserRitualPractices(userId, {
        page: options?.page,
        limit: options?.limit,
        search: options?.search,
        subTab: options?.subTab,
      }),
    enabled: options?.enabled ?? !!userId,
    staleTime: 1000 * 60 * 5,
  })
}
